import React, { useCallback, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, OpenInNew } from "@mui/icons-material";
import Markdown from "markdown-to-jsx";
import "./NCXComponents.styles.css";
import { s360ConfigService } from "../../../Services/S360Config";
import { statsigLogEvent } from "@nextiva/ncx-feature-management";
import {
  LIVECHAT_LOG_ACTIONS,
  LIVECHAT_LOG_EVENTS,
  LIVECHAT_LOG_KEYS,
} from "../../../../utils/Constants/statsig.constants";

export const NCXFAQ = (props) => {
  const { data, id, ticketId, sessionId } = props;
  const containerRef = useRef(null);
  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 200;
      containerRef.current.scrollBy({
        behavior: "smooth",
        left: direction * scrollAmount,
      });
    }
  };
  const parseNewlinesAndEscapes = useCallback((inputText) => {
    const A = ({ children, ...props }) => <a {...props}>{children}</a>;
    if (typeof inputText !== "string") {
      return inputText;
    }
    return (
      <Markdown
        children={inputText}
        options={{
          overrides: {
            a: {
              component: "A",
              props: {
                style: {
                  color: s360ConfigService.config?.configDetails?.primaryColor,
                },
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
          },
        }}
      />
    );
  }, []);

  const handleClickSupportArticle = (articleId, articleTitle, articleUrl) => {
    statsigLogEvent(LIVECHAT_LOG_EVENTS.FAQ_SUPPORT_ARTICLE, {
      [LIVECHAT_LOG_KEYS.action]: LIVECHAT_LOG_ACTIONS.FAQ_SUPPORT_ARTICLE,
      [LIVECHAT_LOG_KEYS.widgetConfigId]:
        s360ConfigService?.config?.widgetconfigId,
      [LIVECHAT_LOG_KEYS.isConnectToNextiva]:
        !!s360ConfigService?.config?.connectToNextiva,
      [LIVECHAT_LOG_KEYS.timeStamp]: Date.now(),
      [LIVECHAT_LOG_KEYS.sessionId]: sessionId,
      articleId,
      articleTitle,
      articleUrl,
    });
  };
  return (
    <>
      <div
        style={{
          background: "#F7F8FA",
          borderRadius: "4px",
          padding: "8px",
          width: "100%",
        }}
      >
        {
          <p style={{ fontSize: "12px" }}>
            {parseNewlinesAndEscapes(data?.data.text)}
          </p>
        }
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "4px",
          }}
        >
          <span
            style={{
              color: "#54687F",
              fontSize: "9px",
              fontWeight: "700",
              textTransform: "uppercase",
            }}
          >
            Suggested articles
          </span>
        </div>
        <div
          style={{ position: "relative" }}
          className="faq-carousel-container"
        >
          {data?.data.orientation === "horizontal" &&
            data?.data.articles.length > 1 && (
              <button
                className="faq-carousel-arrow"
                style={{ left: "2%" }}
                onClick={() => {
                  scroll(-1);
                }}
              >
                <ChevronLeft
                  fontSize="large"
                  key={`${id}-ncxcarouselchevronleft`}
                  style={{ background: "#ddd", borderRadius: "100%" }}
                />
              </button>
            )}

          <div
            style={{
              display: "flex",
              flexDirection:
                data?.data.orientation === "horizontal" ? "row" : "column",
              gap: "4px",
              overflowX:
                data?.data.orientation === "horizontal" ? "auto" : "hidden",
              width: data?.data.orientation === "horizontal" ? "100%" : "auto",
              position: "relative",
            }}
            ref={containerRef}
          >
            {data?.data.articles?.map((article) => {
              return (
                <div
                  key={article.id}
                  style={{
                    alignItems: "center",
                    background: "white",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px",
                    width:
                      data?.data.orientation === "horizontal" ? "100%" : "auto",
                    minWidth:
                      data?.data.orientation === "horizontal"
                        ? "300px"
                        : "auto",
                  }}
                >
                  <div>
                    <h6 style={{ fontWeight: 900, margin: "4px 0" }}>
                      {article.title}
                    </h6>
                    <p style={{ margin: "0px", fontSize: "12px" }}>
                      {article.description}
                    </p>
                  </div>
                  <a
                    href={article.resource_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "4px" }}
                    onClick={() =>
                      handleClickSupportArticle(
                        article.id,
                        article.title,
                        article.resource_url
                      )
                    }
                  >
                    <OpenInNew sx={{ color: "#005fec" }} />
                  </a>
                </div>
              );
            })}
          </div>

          {data?.data.orientation === "horizontal" &&
            data?.data.articles.length > 1 && (
              <button
                className="faq-carousel-arrow"
                style={{ right: "2%" }}
                onClick={() => {
                  scroll(1);
                }}
              >
                <ChevronRight
                  fontSize="large"
                  key={`${id}-ncxcarouselslidecontrollerright`}
                  style={{ background: "#ddd", borderRadius: "100%" }}
                />
              </button>
            )}
        </div>
      </div>
    </>
  );
};
